import { useState } from "react";
import { Box, Container, Tab, Tabs, Typography, Alert, CircularProgress } from "@mui/material";
import IntakeAssignmentView from "./pages/IntakeAssignmentView";
import CoverageMonitorView from "./pages/CoverageMonitorView";
import ScenarioModelerView from "./pages/ScenarioModelerView";
import { useCapacitySnapshot } from "./hooks/useCapacitySnapshot";
import { getDefaultDateRange } from "./utils/dateHelpers";

export default function CapacityManagementLayout() {
  const [activeTab, setActiveTab] = useState(1);

  // Get default 30-day date range
  const dateRange = getDefaultDateRange();

  // Fetch capacity snapshot (using mock data for now)
  const { snapshot, loading, error } = useCapacitySnapshot({
    startDate: dateRange.start,
    endDate: dateRange.end,
    useMockData: true, // TODO: Set to false once backend queries are verified
  });

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Container maxWidth={false}>
      <Box sx={{ py: 3 }}>
        {/* Header */}
        <Typography variant="h4" gutterBottom>
          Capacity Management
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Forward-looking capacity planning and intake assignment
        </Typography>

        {/* Loading State */}
        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress />
          </Box>
        )}

        {/* Error State */}
        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            Error loading capacity data: {error.message}
          </Alert>
        )}

        {/* Data Loaded */}
        {!loading && !error && snapshot && (
          <>
            {/* Tab Navigation */}
            <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
              <Tabs value={activeTab} onChange={handleTabChange}>
                <Tab label="Coverage" value={1} />
                <Tab label="Scenario Modeler" value={2} />
              </Tabs>
            </Box>

            {/* Tab Content */}
            {activeTab === 0 && <IntakeAssignmentView snapshot={snapshot} />}
            {activeTab === 1 && <CoverageMonitorView snapshot={snapshot} />}
            {activeTab === 2 && <ScenarioModelerView snapshot={snapshot} />}
          </>
        )}
      </Box>
    </Container>
  );
}
